// extracted by mini-css-extract-plugin
module.exports = {"w1z0sj4v":"w1z0sj4v","stp2p9w":"stp2p9w"};